module.exports = __webpack_public_path__ + "static/world-2b90a942d3ab8bc6525fdd7d8cceddf5.png";